import React from 'react';
import { FileType } from 'src/components/10-atoms/file-picker/types';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { getFileType } from '../utils';
import ImageThumbnail from './ImageThumbnail';
import PDFThumbnail from './PDFThumbnail';
const AttachmentThumbnail = ({ src, ...thumbnailContainerProps }) => {
    const [{}] = useTheme(stylesGenerator);
    const type = getFileType(src ?? '');
    if (type === FileType.PDF) {
        return React.createElement(PDFThumbnail, { src: src, ...thumbnailContainerProps });
    }
    return React.createElement(ImageThumbnail, { src: src, ...thumbnailContainerProps });
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default AttachmentThumbnail;
